import { useEffect } from 'react';
import { Link } from 'react-router';
import { useLayoutSlots } from '@app/layouts/layoutContext';
import styles from './textPages.module.css';

const APP_VERSION = '1.0.0';

export function AboutRoute() {
  const { setCenter, setRight } = useLayoutSlots();
  useEffect(() => {
    setCenter(
      <article className={styles.page}>
        <h1>Fretnaught</h1>
        <p className={styles.tagline}>
          Offline guitar chord and scale reference. Every key. Every shape. No ads.
        </p>
        <p>Version {APP_VERSION}</p>
        <p>Built by Blayne Robinson · Ontario, Canada</p>
        <h3>Support</h3>
        <p>
          <a href="https://buymeacoffee.com/fretnaught" target="_blank" rel="noopener noreferrer">
            Buy me a coffee
          </a>
        </p>
        <p>
          <a href="mailto:info@fretnaught.app">info@fretnaught.app</a>
        </p>
        <h3>Legal</h3>
        <p>
          <a href="/privacy">Privacy policy</a>
        </p>
        <p>
          <a href="/terms">Terms of service</a>
        </p>
        <p>
          <Link to="/licenses">Open-source licenses</Link>
        </p>
      </article>,
    );
    setRight(null);
    return () => {
      setCenter(null);
      setRight(null);
    };
  }, [setCenter, setRight]);
  return null;
}
